export function isErrorResponse(data) {
    if ("description" in data && "statusCode" in data) {
        return true;
    }
    return false;
}
//# sourceMappingURL=IsErrorResponse.js.map